<template>
	<b-row align-h="center">
		<b-col style="max-width: 1140px;">
			<div class="view-lomake">
				<DynamicForm
					v-if="formConfigs != null"
					:formConfig="formConfigs[$route.params.entity]"
					:orgData="orgData"
				></DynamicForm>
			</div>
		</b-col>
	</b-row>
</template>

<script>
import DynamicForm from "@/components/DynamicForm.vue";
import axios from "axios";

export default {
	name: "Form",
	components: {
		DynamicForm
	},
	watch: {
		$route: {
			handler(to) {
				if (to.params.org) {
					axios.defaults.headers.common["Organization"] = encodeURIComponent(to.params.org);
				}
			},
			immediate: true,
			deep: true
		}
	},
	data() {
		return {
			formConfigs: null,
			orgData: null
		};
	},
	async beforeMount() {
		try {
			let response = await axios.get("general");
			if (response && response.data) {
				const { forms, ...orgData } = response.data;

				if (forms) {
					this.formConfigs = forms;
				}

				if (orgData) {
					this.orgData = orgData;
				}
			}
		} catch (error) {
			console.log(error);
		}
	}
};
</script>

<style lang="scss">
.view-lomake {
	margin-top: 25px;
	margin-bottom: 25px;
}
</style>
